'use strict'
// 服务器端地址
export default {
  // apiurl: '/intelligent_agriculture_webservice' // 本地打包
  // apiurl: 'http://192.168.1.112:8080/intelligent_agriculture_webservice' // 本地打包
  // apiurl: 'http://124.222.91.72:8081/intelligent_agriculture_webservice' // 线上打包
  apiurl: 'http://124.222.91.72:8081/intelligent_agriculture_webservice'
  // apiurl: 'http://120.27.197.248/intelligent_agriculture_webservice' // 习性模型知识库系统
  // apiurl: 'http://192.168.1.113:8008/' // 本地打包
  // apiurl: 'http://192.168.1.113:8008/' // 本地打包
  // apiurl: 'http://192.168.1.65:8008/' // 本地打包
}
